import { Box } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { secondAxios } from "../../../../../api/axios";
import TaskList from "./TaskList";
import { useParams } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { getItps } from "../../../AllEquipments/CommonFeatures/PCSTab/ITP/api";

const normalizeItpTableResponse = (response) => {
  if (Array.isArray(response)) return response;

  if (Array.isArray(response?.data)) return response.data;

  if (Array.isArray(response?.data?.data)) return response.data.data;

  if (Array.isArray(response?.itps)) return response.itps;

  if (Array.isArray(response?.data?.itps)) return response.data.itps;

  return [];
};

const PlantTasksWrapper = ({ type, mrq, materials, isPCSTab = false }) => {
  const queryClient = useMemo(() => new QueryClient(), []);

  const [plant, setPlant] = useState(null);
  const [itpTable, setItpTable] = useState([]);

  const { plantId } = useParams();

  console.log("till progress in plant tasks wrapper", isPCSTab);

  useEffect(() => {
    const getPlant = async () => {
      try {
        const response = await secondAxios.get(`/plant/${plantId}`);
        console.log("selected plant", response.data);
        setPlant(response.data);
      } catch (err) {
        console.error("Error fetching plant:", err);
      }
    };

    if (plantId) {
      getPlant();
    }
  }, [plantId]);

  useEffect(() => {
    const getItpTable = async () => {
      try {
        /*
          If your API expects projectId instead of plantId,
          replace plantId below with the correct project id:
          plant?.projectId || plant?.project?.id || plantId
        */

        const response = await getItps();

        const rows = normalizeItpTableResponse(response);

        console.log("ITP table rows from API", response,plantId);

        setItpTable(rows);
      } catch (err) {
        console.error("Error fetching ITP table:", err);
        setItpTable([]);
      }
    };

    if (plantId) {
      getItpTable();
    }
  }, [plantId]);

  return (
    <QueryClientProvider client={queryClient}>
      <Box sx={{ width: "100%", maxWidth: "100%" }}>
        {plant && (
          <TaskList
            selectedPlant={plant}
            type={type}
            mrq={mrq}
            materials={materials}
            isPCSTab={isPCSTab}
            itpTable={itpTable}
          />
        )}
      </Box>
    </QueryClientProvider>
  );
};

export default PlantTasksWrapper;